module.exports = __webpack_public_path__ + "assets/img/ad_bike.f71b9e6e.png";